import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, ArrowLeft } from "lucide-react";
import { TopBar } from "../components/TopBar";
import { SiteFooter } from "../components/SiteFooter";
import { LightQuestions } from "../components/LightQuestions";
import { LightResults } from "../components/LightResults";
import { ChoosePath } from "../components/ChoosePath";
import { API } from "../lib/api";

const RadarStep = ({ onBack, onNext }) => (
  <section className="evc-radar-full" data-testid="light-radar">
    <iframe
      className="evc-radar-full-frame"
      src={`${API}/dimensions-public`}
      title="The eight dimensions we measure"
      data-testid="light-radar-frame"
    />
    <div className="evc-radar-full-bar">
      <button className="evc-lite-ghost" onClick={onBack} data-testid="light-radar-back">
        <ArrowLeft size={16} /> Back
      </button>
      <span className="evc-radar-full-hint">
        A quick look at the eight dimensions we measure - then choose your path.
      </span>
      <button className="evc-btn evc-lite-next" onClick={onNext} data-testid="light-radar-continue">
        Continue <ArrowRight size={16} />
      </button>
    </div>
  </section>
);

export default function Funnel() {
  const navigate = useNavigate();
  const [step, setStep] = useState("radar");
  const [answers, setAnswers] = useState({});
  const setAnswer = (code, score) => setAnswers((a) => ({ ...a, [code]: score }));

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [step]);

  return (
    <>
      <TopBar hidePrivate />
      {step === "radar" ? (
        <RadarStep onBack={() => navigate("/")} onNext={() => setStep("choice")} />
      ) : (
        <main className="evc-lite-shell" data-testid="light-funnel">
          {step === "choice" && (
            <ChoosePath onLight={() => setStep("questions")} onBack={() => setStep("radar")} />
          )}
          {step === "questions" && (
            <LightQuestions answers={answers} setAnswer={setAnswer}
              onBack={() => setStep("choice")} onFinish={() => setStep("results")} />
          )}
          {step === "results" && <LightResults persona={null} answers={answers} />}
        </main>
      )}
      <SiteFooter />
    </>
  );
}
